<div class="page-container">
    <div class="page-header">
        <button class="btn-back" routerLink="/home/user-management">
            <mat-icon>arrow_back</mat-icon>
            <span>Back to Users</span>
        </button>
        <div class="header-content">
            <h1 class="page-title">{{ isEdit === 'true' ? 'Edit User' : 'Create New User' }}</h1>
            <p class="page-subtitle">{{ isEdit === 'true' ? 'Update user information and permissions' : 'Add a new team member to your organization' }}</p>
        </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="loading-overlay">
        <mat-spinner diameter="50" color="primary"></mat-spinner>
        <p class="loading-text">{{ isEdit === 'true' ? 'Updating user...' : 'Creating user...' }}</p>
    </div>

    <div class="form-card" [class.loading]="isLoading">
        <!-- Personal Information Section -->
        <div class="form-section">
            <div class="section-header">
                <div class="section-icon">
                    <mat-icon>person</mat-icon>
                </div>
                <div class="section-title">
                    <h2>Personal Information</h2>
                    <p>Basic details about the user</p>
                </div>
            </div>

            <div class="form-grid">
                <div class="form-group">
                    <label class="form-label">Khmer Name</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <input matInput [(ngModel)]="khmerName" placeholder="Enter Khmer name" />
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">English Name</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <input matInput [(ngModel)]="englishName" placeholder="Enter English name" />
                    </mat-form-field>
                </div>
            </div>

            <div class="form-group">
                <label class="form-label">Gender</label>
                <div class="radio-group">
                    <mat-radio-group [(ngModel)]="selectedGender" class="gender-radio-group">
                        <label *ngFor="let option of genderOption" class="radio-card" [class.selected]="selectedGender === option">
                            <mat-radio-button [value]="option">
                                <div class="radio-content">
                                    <mat-icon>{{ option === 'Male' ? 'male' : 'female' }}</mat-icon>
                                    <span>{{ option }}</span>
                                </div>
                            </mat-radio-button>
                        </label>
                    </mat-radio-group>
                </div>
            </div>
        </div>

        <!-- Role & Identification Section -->
        <div class="form-section">
            <div class="section-header">
                <div class="section-icon">
                    <mat-icon>badge</mat-icon>
                </div>
                <div class="section-title">
                    <h2>Role & Identification</h2>
                    <p>User role and identity verification</p>
                </div>
            </div>

            <div class="form-grid">
                <div class="form-group">
                    <label class="form-label">User Role</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-select [(value)]="userRolerSelect" placeholder="Select a role">
                            <mat-option *ngFor="let option of userRoleOption" [value]="option">
                                {{ option.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">NID Number</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <input matInput [(ngModel)]="NIDNumber" placeholder="Enter NID number" />
                    </mat-form-field>
                </div>
            </div>

            <div class="form-group">
                <label class="form-label">NID Picture</label>
                <div class="file-upload-container">
                    <div class="file-upload-area" (click)="nidFileInput.click()">
                        <input #nidFileInput type="file" accept=".png, .jpg, .jpeg" (change)="onNIDSelected($event)" hidden>
                        <div class="upload-content" *ngIf="!selectedNIDPic">
                            <mat-icon class="upload-icon">cloud_upload</mat-icon>
                            <span class="upload-text">Click to upload NID picture</span>
                            <span class="upload-hint">PNG, JPG, JPEG (Max 5MB)</span>
                        </div>
                        <div class="preview-content" *ngIf="selectedNIDPic">
                            <img [src]="getImageUrl(selectedNIDPic)" alt="NID Preview" class="preview-image" />
                            <div class="preview-overlay">
                                <mat-icon>edit</mat-icon>
                                <span>Change Image</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Profile Picture Section -->
        <div class="form-section">
            <div class="section-header">
                <div class="section-icon">
                    <mat-icon>photo_camera</mat-icon>
                </div>
                <div class="section-title">
                    <h2>Profile Picture</h2>
                    <p>Upload a profile photo for the user</p>
                </div>
            </div>

            <div class="form-group">
                <div class="profile-upload-container">
                    <div class="profile-upload-area" (click)="profileFileInput.click()">
                        <input #profileFileInput type="file" accept=".png, .jpg, .jpeg" (change)="onProfileSelected($event)" hidden>
                        <div class="profile-placeholder" *ngIf="!selectedProfile">
                            <mat-icon>person_add</mat-icon>
                        </div>
                        <img *ngIf="selectedProfile" [src]="getImageUrl(selectedProfile)" alt="Profile Preview" class="profile-preview" />
                        <div class="profile-edit-badge">
                            <mat-icon>edit</mat-icon>
                        </div>
                    </div>
                    <div class="profile-upload-info">
                        <span class="profile-upload-title">Profile Photo</span>
                        <span class="profile-upload-hint">Click the avatar to upload a new photo</span>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label class="form-label">Employment Date</label>
                <mat-form-field appearance="outline" class="form-field">
                    <input matInput [matDatepicker]="pickupPicker" [value]="formattedDate"
                        (dateChange)="onYearSelected($event)" placeholder="Select date">
                    <mat-datepicker-toggle matIconSuffix [for]="pickupPicker"></mat-datepicker-toggle>
                    <mat-datepicker #pickupPicker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>

        <!-- Account Information Section -->
        <div class="form-section">
            <div class="section-header">
                <div class="section-icon">
                    <mat-icon>lock</mat-icon>
                </div>
                <div class="section-title">
                    <h2>Account Information</h2>
                    <p>Login credentials and security settings</p>
                </div>
            </div>

            <div class="form-grid">
                <div class="form-group">
                    <label class="form-label">Email Address</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">email</mat-icon>
                        <input matInput [(ngModel)]="email" placeholder="user@example.com" type="email" />
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">Username</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">alternate_email</mat-icon>
                        <input matInput [(ngModel)]="username" placeholder="Enter username" />
                    </mat-form-field>
                </div>
            </div>

            @if (isEdit != 'true') {
            <div class="form-grid">
                <div class="form-group">
                    <label class="form-label">Password</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">lock</mat-icon>
                        <input matInput [(ngModel)]="password" [type]="hidePassword ? 'password' : 'text'"
                            placeholder="Enter password" />
                        <button type="button" mat-icon-button matSuffix (click)="hidePassword = !hidePassword" class="toggle-password">
                            <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
                        </button>
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label class="form-label">Confirm Password</label>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-icon matPrefix class="field-icon">lock_outline</mat-icon>
                        <input matInput [(ngModel)]="confirmPassword" [type]="hidePassword ? 'password' : 'text'"
                            placeholder="Confirm password" />
                        <button type="button" mat-icon-button matSuffix (click)="hidePassword = !hidePassword" class="toggle-password">
                            <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
            </div>
            }
        </div>

        <!-- Form Actions -->
        <div class="form-actions">
            <button type="button" class="btn-secondary" routerLink="/home/user-management">
                Cancel
            </button>
            <button type="submit" class="btn-primary" (click)="submitButtonAction()">
                <mat-icon>{{ isEdit === 'true' ? 'save' : 'person_add' }}</mat-icon>
                <span>{{ isEdit === 'true' ? 'Update User' : 'Create User' }}</span>
            </button>
        </div>
    </div>
</div>
